import { render } from "./SocialMediaPostAdd.vue?vue&type=template&id=08d0a9f6"
import script from "./SocialMediaPostAdd.vue?vue&type=script&lang=js"
export * from "./SocialMediaPostAdd.vue?vue&type=script&lang=js"

import exportComponent from "C:\\All Projects\\Digital Sinage Main\\Digital Sinage Admin\\media-device-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__